import React, { useEffect, useRef, useState } from "react";

import Icon1 from "../icons/Icon.js";

import "../animations/animations.css";

import { useSnackbar } from "notistack";

import { useAppContext } from "../config/AppContext.js";

import PrimaryButton from "../buttons/PrimaryButton";

import { Input, Spin } from "antd";

import SecondaryButton from "../buttons/SecondaryButton";

function SmsModalEmail({ userData, handleSuccess, setOpen }) {
  const [code, setCode] = useState("");

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const handleSendSms = async () => {
    // const infos = gatherDeviceInfo();
    // setCode("");
    // sendSmsVerificationCall("user_email", userData.id, infos, prefix);
    handleClickVariant("Un email de vérification a été envoyé", "success");
    setPageState("auth2");
  };

  const [page_state, setPageState] = useState("auth1");
  const handleVerifyCode = async (event) => {
    event.preventDefault();
    try {
      let code_str = code.toString();
      // let res = await VerifySmsCodeCall(
      //   "user_email",
      //   userData.id,
      //   code_str,
      //   prefix
      // );
      // if (res.success) {
      //   handleClickVariant("Code email correct", "success"); // Success notification
      //   handleSuccess(); // Call the success handler with the response data
      //   setOpen(false); // Close the modal
      // } else {
      //   handleClickVariant("Code email incorrect", "error"); // Error notification
      //   setOpen(false); // Close the modal
      // }
    } catch (error) {
      handleClickVariant("Code email incorrect", "error"); // Error notification
      console.error("Error logging in:", error.message);
    }
  };

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  if (page_state === "start") {
    return (
      <div className="flex flex-col w-full h-full  overflow-auto align-middle items-center justify-center">
        <div className="flex flex-col w-fit h-fit p-4 gap-2 bg-white rounded-3xl shadow-xl overflow-auto items-center">
          <Spin spinning={true} size="small" />
        </div>{" "}
      </div>
    );
  }

  if (page_state === "auth1") {
    return (
      <div className="relative  flex flex-col w-fit h-fit  overflow-auto align-middle items-center justify-center ">
        <div className="flex flex-col w-fit h-fit p-4 gap-2 bg-white rounded-3xl shadow-xl overflow-auto items-center">
          <Icon1 icon_name="email" fill="" />
          <div className="text-h2 text-center w-c250 text-shadow_50">
            Bonjour, vous allez recevoir un email pour confirmer votre identité.
          </div>
          <div className=" rounded-xl py-0.5 text-shadow_50 bg-neutral-200 px-2 text-h2 font-semibold w-fit">
            {userData?.email}
          </div>{" "}
          <div className="flex flex-row gap-2">
            <PrimaryButton onClick={handleSendSms}>
              Recevoir le code
            </PrimaryButton>
          </div>
        </div>
      </div>
    );
  }

  const props = {
    renderInput: (props) => (
      <input
        {...props}
        autocomplete="one-time-code"
        name="otp"
        inputMode="numeric" // Ensures numeric keyboard on mobile
      />
    ),
  };

  if (page_state === "auth2") {
    return (
      <div className="flex flex-col w-fit h-fit   overflow-auto align-middle items-center justify-center">
        <div className="flex flex-col w-fit h-fit p-4 gap-2 bg-white rounded-3xl shadow-xl overflow-auto items-center">
          <Icon1 icon_name="smartphone" fill="" />
          <div className="text-h2 text-center w-c250">
            Entrez le code que vous avez reçu.
          </div>

          <div className="w-c250">
            <Input.OTP
              {...props}
              value={code}
              type="number"
              onChange={(e) => {
                setCode(e);
              }}
              numberOfInputs={5}
              length={5}
            />
          </div>

          <div className="flex flex-row gap-2">
            <SecondaryButton onClick={() => setPageState("auth1")}>
              Retour
            </SecondaryButton>
            <PrimaryButton
              disabled={code.length < 5}
              onClick={handleVerifyCode}
            >
              Vérifier
            </PrimaryButton>
          </div>
        </div>
      </div>
    );
  }
  return null;
}

export default SmsModalEmail;
